// src/components/Layout.js
import React from 'react';
import Header from './Header';
import BottomNav from './BottomNav';
import { Outlet } from 'react-router-dom';

export default function Layout() {
  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <main className="site-layout-content px-4">
        <Outlet />
      </main>
      <BottomNav />
    </div>
  );
}
